module.exports = __webpack_public_path__ + "img/message-attent.733617d0.png";